import './app-config';
import { appConfigModule } from '../../../shared/app/constants/app-config';
import { angularCoreConfigModule } from '../../../shared/app/config/angular-core';

export const configModule = angular
  .module('Q.config', [appConfigModule, angularCoreConfigModule])
  .config(function ($anchorScrollProvider) {
    $anchorScrollProvider.disableAutoScrolling();
  });
